// Routes Manifest CSV. Header and row are built side by side so their columns stay aligned.
// `Truck` and `Resource` hold the same value: consumers read this export by header, and `Resource`
// sits last so anyone reading by position still finds every other column where it was.

const ORDER_HEADER = [
    'Route',
    'Carrier',
    'Driver',
    'Truck',
    'Stop #',
    'Order #',
    'PO #',
    'Customer',
    'Phone',
    'Address 1',
    'Address 2',
    'City',
    'State',
    'Zip',
    'Time Frame',
];

const ITEM_HEADER = ['Item ID', 'SKU', 'Description', 'Barcode', 'Weight', 'Cubes'];

const TOTALS_HEADER = ['Total Items', 'Total Weight', 'Total Cubes'];

export const manifestCsvHeader = (itemExtension) => [
    ...ORDER_HEADER,
    ...(itemExtension ? ITEM_HEADER : TOTALS_HEADER),
    'Resource',
];

const orderCells = (pdfData, order) => [
    pdfData.route_number,
    pdfData.carrier,
    pdfData.assignee,
    pdfData.resource,
    order.stop_number,
    order.order_number,
    order.po_number,
    order.customer_name,
    order.customer_phone,
    order.customer_address1,
    order.customer_address2,
    order.customer_city,
    order.customer_state,
    order.customer_zip,
    order.time_frame,
];

export const manifestCsvItemRow = (pdfData, order, item) => [
    ...orderCells(pdfData, order),
    item.item_id,
    item.sku,
    item.description,
    item.barcode,
    item.weight,
    item.cubes,
    pdfData.resource,
];

export const manifestCsvOrderRow = (pdfData, order) => {
    const totalItems = order.items.length;
    const totalWeight = order.items.reduce((sum, item) => sum + (parseInt(item.weight) || 0), 0);
    const totalCubes = order.items.reduce((sum, item) => sum + (parseInt(item.cubes) || 0), 0);

    return [...orderCells(pdfData, order), totalItems, totalWeight, totalCubes, pdfData.resource];
};
